<div class="not-supported-header-container">
  <glxy-empty-state class="not-supported-state-container">
    <glxy-empty-state-hero>
      <mat-icon>schedule</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title class="not-supported-title">
      {{
        'EMPTY_STATE.NOT_SUPPORTED.TITLE'
          | translate: { snapshotName: snapshotName }
      }}
    </glxy-empty-state-title>
  </glxy-empty-state>
</div>
